import React, {useState} from 'react';
import {Link} from 'react-router-dom';

// Material UI
import MenuIcon from '@material-ui/icons/Menu';
import Follow from './Follow';

import './Navbar.css';
import '../../generalCSS/style.css';

function Navbar() {
  const [navbarOpen, setNavbarOpen] = useState(true);
  const handleMenuToggle = () => setNavbarOpen(!navbarOpen);

  return (
    <div className="navbar">
      <div className="navbar__firstContainer container">
        <div className="navbar__container">
          <div
            className={`navbar__newsletter show-desktop ${
              navbarOpen ? 'hide-mobile' : ''
            }`}
          >
            <a href="#newsletter" onClick={handleMenuToggle}>
              newsletter
            </a>
          </div>
          <div
            className={`navbar__left show-desktop ${
              navbarOpen ? 'hide-mobile' : ''
            }`}
          >
            <ul>
              <li>
                <Link to="/news">news</Link>
              </li>
              <li>
                <Link to="/music">music</Link>
              </li>
              <li>
                <Link to="/videos">media</Link>
              </li>
            </ul>
          </div>
          <div className="navbar__middle">
            <div className="navbar__logo">
              <Link to="/" className="logo">
                Bruce Melody
              </Link>
            </div>
          </div>
          <div
            className={`navbar__right show-desktop ${
              navbarOpen ? 'hide-mobile' : ''
            }`}
          >
            <ul>
              <li>
                <Link to="/tour">tour</Link>
              </li>
              <li>
                <a href="https://musicianstore.netlify.app/" target="_blank" rel="noreferrer">shop</a>
              </li>
              <li>
                <Link to="/contact">contact</Link>
              </li>
            </ul>
          </div>
          <div
            className={`navbar__follow__newsletter show-desktop ${
              navbarOpen ? 'hide-mobile' : ''
            }`}
          >
            <Follow />
          </div>
        </div>
        <div className="navbar__menuIcon">
          <MenuIcon className="menu" onClick={handleMenuToggle} />
        </div>
      </div>
    </div>
  );
}

export default Navbar;
